import React from "react";
import {
	Datagrid,
	DateInput,
	DateTimeInput,
	Filter,
	List,
	Pagination,
	ReferenceField,
	ReferenceInput,
	SelectInput,
	TextField,
	TextInput,
	useRecordContext,
} from "react-admin";
import Typography from "@mui/material/Typography";

const DonationNameField = () => {
	const record = useRecordContext();

	return (
		<Typography component="span" variant="body2">
			{record?.firstname} {record?.lastname}
		</Typography>
	);
};

const DonationAmountField = () => {
	const record = useRecordContext();

	return (
		<Typography component="span" variant="body2">
			{record?.amount}€
		</Typography>
	);
};

const DonationCampaignField = () => (
	<ReferenceField source="campaign_id" reference="campaign" basePath="/campaign" link="show">
		<TextField source="abstract_title" />
	</ReferenceField>
);

const DonationFilter = (props) => (
	<Filter {...props}>
		<DateInput source="donation_date@_gte" label="Date de donation (à partir de)" alwaysOn />
		<DateInput
			source="donation_date@_lte"
			label="Date de donation (jusqu'à)"
			alwaysOn
			format={(v) => {
				if (!v) return;

				const d = new Date(v);

				// Remove the day added in the parse function
				d.setDate(d.getDate() - 1);
				return `${d.getFullYear().toString().padStart(4, "0")}-${(d.getMonth() + 1)
					.toString()
					.padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
			}}
			parse={(v) => {
				if (!v) return;

				const d = new Date(v);
				d.setDate(d.getDate() + 1);
				// If we choose 12 June
				// Store in the form 13 June at 00:00:01s

				return `${d.getFullYear().toString().padStart(4, "0")}-${(d.getMonth() + 1)
					.toString()
					.padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}T00:00:01.000+00:00`;
			}}
		/>
		<ReferenceInput source="campaign_id" reference="campaign">
			<SelectInput label="Campagne" optionText="abstract_title" />
		</ReferenceInput>
		<TextInput label="Code Origin" source="origin_code" />
		<TextInput label="Affectation" source="affectation_code" />
	</Filter>
);

const DonationPagination = (props) => <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />;

const DonationList = (props) => (
	<List
		{...props}
		filters={<DonationFilter />}
		pagination={<DonationPagination />}
		perPage={50}
		sort={{
			field: "created_date",
			order: "DESC",
		}}
	>
		<Datagrid rowClick="show">
			<DonationNameField label="Donateur" />
			<DonationAmountField label="Montant" />
			<ReferenceField
				label="Campagne"
				source="campaign_id"
				reference="campaign"
				basePath="/campaign"
				link="show"
			>
				<TextField source="abstract_title" />
			</ReferenceField>
			<TextField label="Code Origin" source="origin_code" />
			<TextField label="Affectation" source="affectation_code" />
		</Datagrid>
	</List>
);

export default DonationList;
